import { apiClient } from './client';

export interface LeaderRow {
  rank: number;
  name: string;
  net: string;
  wins: number;
}

export const leaderboardApi = {
  top: (limit = 20) =>
    apiClient.get<LeaderRow[]>(`/leaderboard/top?limit=${limit}`).then((r) => r.data),
};
